import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './subscription.types';
import * as constants from './subscription.constants';

export const subscriptionReducer = generateResourceReducer<types.ISubscription>({
  STORE: constants.STORE_SUBSCRIPTION,
  CLEAR: constants.CLEAR_SUBSCRIPTION,
});
